var styleDataHash = 'ce09a8fb';  
export const injectCss = (() => {
  var css = `.Jv0Vl{align-items:center;color:#414141;display:flex;font-size:14px;justify-content:start;max-width:375px}[dir] .Jv0Vl{background-color:#f0f4f7;border-radius:10px;margin:0 auto;padding:8px}.Jv0Vl svg{flex-shrink:1;height:100%;max-height:24px;max-width:24px;width:100%}[dir] .Jv0Vl svg{margin:0 8px}[dir] .Jv0Vl p{margin:0}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "genericError": "Jv0Vl"
};